import { extend } from 'vee-validate';
import { required, numeric, min_value,  max_value, integer, email, length, confirmed, between } from 'vee-validate/dist/rules';

extend('numeric', numeric);
extend('min_value', min_value);
extend('max_value', max_value);

extend('between', {
  ...between,
  message: (_field, { min, max }) => `${_field} must be between ${min} and ${max}`
});
extend('required', {
  ...required,
  message: (_field) => `${_field} is required.`
});
extend('integer', integer);

extend('phoneNumber', {
  validate(value) {
    return value.match(/^\+[1-9]\d{10,14}$/);
  },
  message: 'Invalid Phone Number'
});

// Caller ID search accepts an E.164 number with or without the leading `+` (the `+` is stripped
// before the request). Looser than `phoneNumber` so users can paste a bare digit string.
extend('callerId', {
  validate(value) {
    return value.match(/^\+?[1-9]\d{9,14}$/);
  },
  message: 'Invalid Caller ID'
});

extend('no800', {
  validate(value) {
    return value != '800';
  },
  message: 'Contact Ringba Support to add numbers with the 800 prefix.'
});

extend('email', email);
extend('length', length);
extend('confirmed', confirmed);
extend('passwordMatch', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: 'Passwords must match.'
});

extend('password', {
  validate(value) {
    return value.match('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[.,!@#$%^&*])(?=.{8,})') != null;
  },
  message: 'Must contain at least one of each of the following: lower & uppercase letter, number, and symbol.'
});

extend('passwordLength', {
  validate(value) {
    return value.length >= 8;
  },
  message: 'Must be at least 8 characters.'
});

extend('url', {
  validate(value) {
    return value.match(/^(http:\/\/|https:\/\/)+([0-9A-Za-z-]+\.)(\/)?([0-9A-Za-z]*(\.|-)*[0-9A-Za-z]*(\/)?)?(\?)?([0-9A-Za-z]+=[0-9A-Za-z]+(&)?)*/) != null;
  },
  message: 'Must be a valid URL'
});

extend('notZero', {
  validate(value) {
    return value !== 0;
  },
  message: 'Must be greater than 0'
});

extend('cvv', {
  validate(value) {
    return value.match('^\\d{3,4}$') != null;
  },
  message: 'Must be a valid CVV'
});

extend('luhn', {
  validate(value) {
    let sum = 0;
    let isEven = false;
    const cardNumber = value.replace(/\s+/g, '');

    for (let i = cardNumber.length - 1; i >= 0; i--) {
      let digit = parseInt(cardNumber.charAt(i), 10);

      if (isEven) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }

      sum += digit;
      isEven = !isEven;
    }

    return sum % 10 === 0;
  },
  message: 'Must be a valid credit card number'
});